<script>
   /**************************************************************/
   /* Svelte component for DistancePlot settings                 */
   /**************************************************************/

   import {  Container, CompSelector } from '../controls';

   export let model;
   export let params;
   export let pvoptions;
   export let res;

   let ncomp = 1;

   $: params = {
      ncomp
   }
</script>

<Container label="">
<p class="title">Distances</p>
</Container>

{#if model && res && pvoptions}
<CompSelector bind:value={ncomp} label="# LVs" maxNComp={pvoptions.ncompSel} />
{/if}
